import * as Yup from "yup";

export function initialValues() {
  return {
    classnumber: [], // Array para guardar clases
    newClass: "", // Input temporal para una nueva clase
  };
}

export function validationSchema() {
  return Yup.object({
    classnumber: Yup.array()
      .of(Yup.string().required("El número de clase es obligatorio"))
      .min(1, "Debe añadir al menos una clase"),
  });
}
